<template>
  <v-expansion-panel-content>
    <Navigate :previous="onlyAcc" />
    <p v-if="!onlyAcc"><v-btn @click="()=>{this.$router.go()}">Go Back</v-btn></p>
    <h6>Other Products</h6>
    <p class="sub-text-custom">
      Products on this page are not part of custom seat covers. No seat cover purchase is required.
    </p>
    <section class="opt-sec">
      <v-row>
        <ProductDetails
          v-for="product in accessoriesList"
          v-bind="product"
          :key="product.partNumber"
          withActions
        />
      </v-row>
    </section>
    <Total />
    <Navigate :previous="onlyAcc" next :valid="validate" />
  </v-expansion-panel-content>
</template>

<style scoped lang="scss">
h5 {
  font-family: $body-font-family !important;
  font-size: 20px;
  font-weight: 700;

  @media screen and (min-width: 600px) {
    font-size: 30px;
  }
}
h6 {
  font-family: $body-font-family !important;
  font-size: 22px;
  font-weight: 700;
  margin-top: 40px;
  margin-bottom: 5px;
}
.sub-text-custom {
  padding: 10px 0 !important;
}
.top-nav {
  margin-top: 20px;
}
.opt-sec {
  margin-top: 15px;
}
</style>
<script>
  import Products from '../services/accessories'
  import { mapGetters } from 'vuex'
  import Total from './Total'
  import Navigate from './Navigate'
  import ProductDetails from './AccessoryDetails'

  export default {
    components: {
      Total,
      Navigate,
      ProductDetails
    },
    props: {
      onlyAcc: Boolean
    },
    computed: {
      ...mapGetters(['accessoriesList']),
      validate() {
        return true
      }
    },
    mounted () {
      this.getProducts()
    },
    methods: {
      async getProducts () {
        const products = await Products.get()
        this.$store.commit('setAccessories', products)
      }
    }
  }
</script>
